module.exports = __webpack_public_path__ + "img/question_showship.170c51d9.svg";